import { storage } from '@service-victoria/component-library/utils/storage';

import * as Interfaces from 'interfaces';
import { constants } from 'utils';

export type Methods<T> = {
  /**
   * get serialized object stored in the local storage
   */
  getItem(): T;
  /**
   * update storage data with given key and object of value
   * @param value value to overwrite previous item inside the store
   */
  setItem(value: T): void;
  /**
   * remove an item from the storage
   * @param key key to remove
   */
  removeItem(): void;
  /**
   * clear the storage from all items
   */
  clear(): void;
};

/**
 * Load a named storage collection
 * @param key store key
 * @param storage type of storage to use (usually sessionStorage or localStorage)
 */
function getNamedStorage<T extends Record<string, unknown>>(
  key: string,
  namedStorage: Storage
): Methods<T> {
  const store = storage<T>(namedStorage);
  return {
    getItem: () => store.getItem(key),
    clear: store.clear,
    removeItem: () => store.removeItem(key),
    setItem: value => store.setItem(key, value)
  };
}

const Storage = getNamedStorage<Interfaces.Store.State>(
  constants.StorageKeys.State,
  sessionStorage
);

export default Storage;
